// COLORS:
// skinColor shirtColor pantsColor shoeColor hairColor, sleeveColor

// CLASSES:
module.exports = [{
  name: "Triggerman",
  loadout: [1],
  secondary: true,
  colors: [0xa77860, 0x3d3d3d, 0x232323, 0x282828, 0x6c5042, 0xbfbfbf],
  health: 100,
  segs: 6,
  speed: 1.05
}, {
  name: "Hunter",
  loadout: [0],
  secondary: true,
  colors: [0xa77860, 0x7b573d, 0x634732, 0x282828, 0x634732, 0x3d2b1d],
  health: 60,
  segs: 5,
  speed: 1.05
}, {
  name: "Run N Gun",
  loadout: [3],
  colors: [0xa77860, 0x3e6382, 0x2f4b63, 0x282828, 0x634732, 0x1a2b3a],
  health: 100,
  segs: 6,
  speed: 1.18
}, {
  name: "Spray N Pray",
  loadout: [6],
  txts: ["Calling in the Big Guns?", "Remember - No russian.", "Pesky Snipers..."],
  colors: [0xa77860, 0x586849, 0x49563c, 0x282828, 0x282828, 0x303827],
  health: 170,
  segs: 7,
  regen: 0.05,
  speed: 1.0
}, {
  name: "Vince",
  loadout: [5],
  secondary: true,
  colors: [0x805c4a, 0x545267, 0x3f3d4d, 0x282828, 0x282828, 0x292833],
  health: 100,
  segs: 6,
  speed: 1.0
}, {
  name: "Detective",
  loadout: [4],
  colors: [0xa77860, 0x704e36, 0x434c5e, 0x282828, 0x634732, 0x3f2c1e],
  health: 100,
  segs: 6,
  speed: 1
}, {
  name: "Marksman",
  loadout: [7],
  secondary: true,
  colors: [0xa77860, 0x586849, 0x49563c, 0x282828, 0x282828, 0x293022],
  health: 90,
  segs: 6,
  speed: 1.0
}, {
  name: "Rocketeer",
  loadout: [8],
  secondary: true,
  txts: ["..."],
  colors: [0xa77860, 0x586849, 0x49563c, 0x282828, 0x6c5042, 0x2b3324],
  health: 130,
  segs: 7,
  speed: 0.86
}, {
  name: "Agent",
  loadout: [9],
  colors: [0xa77860, 0x3d3d3d, 0x232323, 0x282828, 0x282828, 0xbfbfbf],
  health: 100,
  segs: 6,
  speed: 1.2
}, {
  name: "Runner",
  txts: ["You sure about this?", "...", "Oh boy", "I don't know about this...", "Not me again..."],
  loadout: [12],
  colors: [0xa77860, 0x3d3d3d, 0x232323, 0x282828, 0x282828, 0x232323],
  health: 100,
  segs: 6,
  regen: 0.2,
  speed: 1.0
}, {
  name: "Deagler",
  hide: true,
  loadout: [10],
  colors: [0xa77860, 0x3d3d3d, 0x232323, 0x282828, 0x282828, 0x232323],
  health: 60,
  segs: 5,
  speed: 1.0
}, {
  name: "Bowman",
  loadout: [13],
  secondary: true,
  colors: [0xa77860, 0x916c52, 0x60432e, 0x282828, 0x282828, 0x473527],
  health: 100,
  segs: 6,
  speed: 1.0
}];